<template>
	<!-- NOTIFICATIONS -->
	<div>
		<vs-dropdown vs-custom-content :vs-trigger-click="false" class="button-notification cursor-pointer">
			<transition name="bounce">
				<p>
					<feather-icon
						icon="BellIcon"
						class="cursor-pointer mt-1 sm:mr-6 mr-2"
						:badge="totalUnreadNotifications"
						:svgClasses="[show ? `text-prymary` : `text-warning`, 'stroke-current mr-1 h-6 w-6']"
					/>
				</p>
			</transition>

			<vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">
				<div class="notification-top text-center p-5 bg-primary text-white">
					<h3 class="text-white">{{ totalUnreadNotifications }} {{ $t("Notification.New") }}</h3>
					<p class="opacity-80">{{ $t("Notification.AppNotifications") }}</p>
				</div>

				<component
					:is="scrollbarTag"
					ref="mainSidebarPs"
					class="scroll-area--nofications-dropdown p-0 mb-10"
					:settings="settings"
					:key="$vs.rtl"
				>
					<div
						v-if="is_notification"
						class="rounded-b-lg text-primary w-full p-2 text-right border border-b-1 border-l-0 border-r-0 border-solid d-theme-border-grey-light"
					>
						<span v-if="totalUnreadNotifications > 0" @click="confirmDeleteAllNotification">
							<feather-icon
								:title="$t('Notification.DeleteAllNotifications')"
								icon="Trash2Icon"
								class="cursor-pointer mt-1 sm:mr-6 mr-2 cursor-pointer hover:text-danger"
								:svgClasses="[show ? `text-prymary` : `text-warning`, 'stroke-current mr-1 h-6 w-6']"
						/></span>

						<span>
							<feather-icon
								:title="$t('GoTo') + ' ' + $t('Preferences.Preferences')"
								icon="SettingsIcon"
								class="cursor-pointer mt-1 sm:mr-6 mr-2 cursor-pointer hover:text-success"
								@click="$router.push({name: 'dashboard-preferences', params: {id: 'notifications'}})"
								:svgClasses="[show ? `text-prymary` : `text-warning`, 'stroke-current mr-1 h-6 w-6']"
						/></span>
					</div>
					<div
						v-else
						class="rounded-b-lg text-primary w-full p-2 border border-b-1 border-l-0 border-r-0 border-solid d-theme-border-grey-light"
					>
						<span
							v-if="!is_notification"
							class="flex items-center font-bold cursor-pointer ml-2 hover:text-danger"
							@click="is_notification = true"
						>
							<feather-icon
								:title="$t('Notification.DeleteAllNotifications')"
								icon="ArrowLeftIcon"
								class="cursor-pointer"
								:svgClasses="['stroke-current h-6 w-6']"
							/>{{ $t("Back") }}
						</span>
					</div>
					<ul class="bordered-items">
						<div v-show="is_notification">
							<li
								v-for="ntf in unreadNotifications"
								:key="ntf.key"
								class="flex justify-between px-4 py-4 notification cursor-pointer"
							>
								<div class="flex items-start" @click="readNotification(ntf)">
									<feather-icon
										title="Revisar"
										:icon="notificationIcon(ntf.event)"
										:svgClasses="[
											`text-${category(ntf.event)}`,
											'stroke-current mr-1 h-6 w-6 hover:text-primary',
										]"
									></feather-icon>
									<div class="mx-2">
										<span
											class="font-medium block notification-title"
											:class="[`text-${category(ntf.event)}`]"
											>{{ notificationTitle(ntf) }}</span
										>
										<small class="font-semibold">{{ notificationText(ntf) | title }}</small>
										<vs-progress
											v-if="showProgress(ntf.event)"
											:indeterminate="indeterminateProgress(ntf.event)"
											:percent="currentProgress(ntf.event)"
											class="block mt-1 shadow-md w-full"
											color="success"
										></vs-progress>
										<p v-if="showLoaded(ntf.event)">
											<feather-icon
												icon="UploadCloudIcon"
												:svgClasses="[`text-success`, 'stroke-current mr-1 h-6 w-6']"
											></feather-icon>
										</p>
									</div>
								</div>
								<small class="mt-1 whitespace-no-wrap">
									{{ elapsedTime(ntf.added_on) }} <br />
									<span
										v-if="shoView(ntf)"
										class="text-primary underline ml-4"
										style="cursor: pointer"
										@click="readNotification(ntf, true)"
										>{{ $t("View") }}</span
									>
									<span
										v-else-if="viewMore(ntf)"
										class="text-primary underline"
										style="cursor: pointer"
										@click="showNotificationView(ntf)"
										>{{ $t("ViewMore") }}
										<feather-icon
											icon="ArrowRightIcon"
											:svgClasses="['stroke-current h-4 w-4']"
										></feather-icon>
									</span>
								</small>
							</li>
						</div>
						<transition name="slide-fade">
							<li
								v-if="!is_notification"
								class="flex justify-between px-4 py-4 notification cursor-pointer"
							>
								<notification-view-optimization
									v-if="notificationSelected.event === 'OPTIMIZATION_DONE'"
									:data="notificationSelected"
									:iconRight="true"
								/>
								<notification-view v-else :data="notificationSelected" :iconRight="true" />
							</li>
						</transition>
					</ul>
				</component>
			</vs-dropdown-menu>
		</vs-dropdown>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import firebase from "firebase/app";
import User from "@/models/User.js";
import Notification from "@/models/Notification.js";
import DateUtils from "@/helpers/DateUtils.js";
import {EventBus} from "@/helpers/eventBus.js";
import moment from "moment";
import NotificationView from "./NotificationView.vue";
import NotificationViewOptimization from "./NotificationViewOptimization.vue";

export default {
	components: {
		VuePerfectScrollbar,
		NotificationView,
		NotificationViewOptimization,
	},
	data() {
		return {
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			notifications: [],
			database: firebase.database(),
			userSession: new User(),
			show: true,
			notificationsDays: 1,
			notificationsNumber: 1,
			removeOldNotifications: false,
			totalUnreadNotifications: 0,
			userData: "",
			pathRefNofication: "",
			notificationSelected: {},
			is_notification: true,
			url: "",
			lat: "",
			lng: "",
		};
	},
	computed: {
		notify_alert_configjson() {
			return this.$store.getters.getConfigjsonRequiredNotifyStatus();
		},
		notify_alert_type() {
			return this.$store.getters.getConfigjsonRequiredName();
		},
		notificationTitle() {
			return (notification) => {
				let text = "";
				switch (notification.event) {
					case "ROUTING_DONE":
						text = this.$t("Notification.FINALIZED");
						break;
					case "ROUTING_PROCESS":
						text = this.$t("Notification.PROCESS");
						break;
					case "ROUTING_ERROR":
						text = this.$t("Notification.ERRORINFILE");
						break;
					case "OPTIMIZATION_DONE":
						text = this.$t("Notification.FINALIZED");
						break;
					case "OPTIMIZATION_PROCESS":
						text = this.$t("Notification.PROCESSINGOPTIMIZATION");
						break;
					case "OPTIMIZATION_ERROR":
						text = this.$t("Notification.OPTIMIZATIONERROR");
						break;
					case "UPLOAD_VP_FINALIZED":
						text = this.$t("Notification.FINALIZED");
						break;
					case "UPLOAD_VP_ERROR":
						text = this.$t("Notification.ERRORINFILE");
						break;
					case "UPLOAD_VP_LOADED":
						text = this.$t("Notification.LOADED");
						break;
					case "UPLOAD_VP_PROCESS":
						text = this.$t("Notification.PROCESS");
						break;
					case "UPLOAD_VH_FINALIZED":
						text = this.$t("Notification.FINALIZED");
						break;
					case "UPLOAD_VH_ERROR":
						text = this.$t("Notification.ERRORINFILE");
						break;
					case "UPLOAD_VH_LOADED":
						text = this.$t("Notification.LOADED");
						break;
					case "UPLOAD_VH_PROCESS":
						text = this.$t("Notification.PROCESS");
						break;
					case "LOADED":
						text = this.$t("Notification.LOADED");
						break;
					case "PROCESS":
						text = this.$t("Reports.Reports").toUpperCase();
						break;
					case "FINALIZED":
						if (notification.title === "Upload Finalized") {
							text = this.$t("Notification.FINALIZED");
						} else {
							text = this.$t("Reports.ReportGeneratedText");
						}
						break;
					default:
						text = notification.title.toUpperCase();
						break;
				}
				return text;
			};
		},
		notificationText() {
			return (notification) => {
				let text = "";
				switch (notification.event) {
					case "ROUTING_DONE":
						text = this.$t("Notification.UPLOAD_FILE_OP");
						break;
					case "ROUTING_PROCESS":
						text = this.$t("Notification.UPLOAD_FILE");
						break;
					case "OPTIMIZATION_DONE":
						text = this.$t("Notification.DONE_OP");
						break;
					case "OPTIMIZATION_PROCESS":
						text = this.$t("Notification.CREATE_OPTIMIZATION");
						break;
					case "OPTIMIZATION_ERROR":
						text = this.$t("Notification.CREATE_OPTIMIZATION");
						break;
					case "UPLOAD_VP_FINALIZED":
						text = this.$t("Notification.UPLOAD_FILE_PV");
						break;
					case "UPLOAD_VP_ERROR":
						text = this.$t("Notification.UPLOAD_FILE");
						break;
					case "UPLOAD_VP_PROCESS":
						text = this.$t("Notification.UPLOAD_FILE");
						break;
					case "UPLOAD_VH_FINALIZED":
						text = this.$t("Notification.UPLOAD_FILE_PV");
						break;
					case "UPLOAD_VH_ERROR":
						text = this.$t("Notification.UPLOAD_FILE");
						break;
					case "UPLOAD_VH_PROCESS":
						text = this.$t("Notification.UPLOAD_FILE");
						break;
					case "PROCESS":
						text = this.$t("Reports.ProcessingReport");
						break;
					case "FINALIZED":
						if (notification.title === "Upload Finalized") {
							text = this.$t("Notification.LOADED");
						} else {
							text = this.$t("Reports.ReportGeneratedText");
						}
						break;
					default:
						text = notification.event;
						break;
				}
				return text;
			};
		},
		notificationIcon() {
			return (typeEvent) => {
				let iconName = "";
				switch (typeEvent) {
					case "ROUTING_DONE":
						iconName = "FileTextIcon";
						break;
					case "ROUTING_ERROR":
						iconName = "FrownIcon";
						break;
					case "ROUTING_PROCESS":
						iconName = "CpuIcon";
						break;
					case "OPTIMIZATION_DONE":
						iconName = "CheckCircleIcon";
						break;
					case "OPTIMIZATION_PROCESS":
						iconName = "RefreshCcwIcon";
						break;
					case "OPTIMIZATION_ERROR":
						iconName = "AlertCircleIcon";
						break;
					case "UPLOAD_VP_FINALIZED":
						iconName = "FileTextIcon";
						break;
					case "UPLOAD_VP_LOADED":
						iconName = "FilePlusIcon";
						break;
					case "UPLOAD_VP_PROCESS":
						iconName = "CpuIcon";
						break;
					case "UPLOAD_VH_FINALIZED":
						iconName = "FileTextIcon";
						break;
					case "UPLOAD_VH_LOADED":
						iconName = "FilePlusIcon";
						break;
					case "UPLOAD_VH_PROCESS":
						iconName = "CpuIcon";
						break;
					case "LOADED":
						iconName = "FilePlusIcon";
						break;
					case "PROCESS":
						iconName = "CpuIcon";
						break;
					case "FINALIZED":
						iconName = "FileTextIcon";
						break;
					default:
						iconName = "MessageSquareIcon";
						break;
				}
				return iconName;
			};
		},
		category() {
			return (typeEvent) => {
				switch (typeEvent) {
					case "ROUTING_DONE":
						return "success";
					case "ROUTING_ERROR":
						return "danger";
					case "ROUTING_PROCESS":
						return "primary";
					case "OPTIMIZATION_DONE":
						return "success";
					case "OPTIMIZATION_PROCESS":
						return "primary";
					case "OPTIMIZATION_ERROR":
						return "danger";
					case "UPLOAD_VP_FINALIZED":
						return "success";
					case "UPLOAD_VP_ERROR":
						return "danger";
					case "UPLOAD_VP_LOADED":
						return "primary";
					case "UPLOAD_VP_PROCESS":
						return "primary";
					case "UPLOAD_VH_FINALIZED":
						return "success";
					case "UPLOAD_VH_ERROR":
						return "danger";
					case "UPLOAD_VH_LOADED":
						return "primary";
					case "UPLOAD_VH_PROCESS":
						return "primary";
					case "LOADED":
						return "primary";
					case "FINALIZED":
						return "success";
					case "PROCESS":
						return "danger";
					default:
						return "secondary";
				}
			};
		},
		showProgress() {
			return (typeEvent) => {
				switch (typeEvent) {
					case "ROUTING_DONE":
						return false;
					case "OPTIMIZATION_DONE":
						return false;
					case "UPLOAD_VP_FINALIZED":
						return false;
					case "UPLOAD_VH_FINALIZED":
						return false;
					case "ROUTING_PROCESS":
						return true;
					case "OPTIMIZATION_PROCESS":
						return true;
					case "UPLOAD_VP_PROCESS":
						return true;
					case "UPLOAD_VH_PROCESS":
						return true;
					case "PROCESS":
						return true;
					default:
						return false;
				}
			};
		},
		indeterminateProgress() {
			return (typeEvent) => {
				switch (typeEvent) {
					case "ROUTING_PROCESS":
						return true;
					case "OPTIMIZATION_PROCESS":
						return true;
					case "UPLOAD_VP_PROCESS":
						return true;
					case "UPLOAD_VH_PROCESS":
						return true;
					case "PROCESS":
						return true;
					default:
						return false;
				}
			};
		},
		showLoaded() {
			return (typeEvent) => {
				switch (typeEvent) {
					case "UPLOAD_VP_LOADED":
						return true;
					case "UPLOAD_VH_LOADED":
						return true;
					case "LOADED":
						return true;
					default:
						return false;
				}
			};
		},
		currentProgress() {
			return (typeEvent) => {
				switch (typeEvent) {
					case "FINALIZED":
						return 100;
					case "LOADED":
						return 50;
					case "UPLOAD_VP_FINALIZED":
						return 100;
					case "UPLOAD_VH_FINALIZED":
						return 100;
					case "OPTIMIZATION_DONE":
						return 100;
					case "UPLOAD_VP_LOADED":
						return 50;
					case "UPLOAD_VH_LOADED":
						return 50;
					default:
						return 0;
				}
			};
		},
		shoView() {
			return (notification) => {
				if (notification.event === "FINALIZED") {
					return notification.title !== "Upload Finalized";
				}
				return false;
			};
		},
		viewMore() {
			return (notification) => {
				switch (notification.event) {
					case "UPLOAD_VP_FINALIZED":
						return true;
					case "UPLOAD_VH_FINALIZED":
						return true;
					case "OPTIMIZATION_DONE":
						return true;
					default:
						return false;
				}
			};
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
		unreadNotifications() {
			return this.notifications.sort(this.compare);
		},
		readAvalibleEventsNotificationTrigger() {
			return this.$store.getters.getReadAvalibleEventsNotificationTrigger;
		},
		requiredPermissions() {
			return this.$store.getters.getRequiredPermissionsTrigger;
		},
		requiredPermissionsData() {
			return this.$store.getters.getRequiredPermissionsData;
		},
		deleteNotificationTrigger() {
			return this.$store.getters.getDeleteNotificationTrigger;
		},
		reloadNotificationTrigger() {
			return this.$store.getters.getReloadNotificationTrigger;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		elapsedTime(startTime) {
			const x = new Date(startTime);
			const now = new Date();
			let timeDiff = now - x;
			timeDiff /= 1000;
			moment().diff(x, "days");
			const seconds = Math.round(timeDiff);
			timeDiff = Math.floor(timeDiff / 60);
			const minutes = Math.round(timeDiff % 60);
			timeDiff = Math.floor(timeDiff / 60);
			const hours = Math.round(timeDiff % 24);
			timeDiff = Math.floor(timeDiff / 24);
			const days = Math.round(timeDiff % 365);
			timeDiff = Math.floor(timeDiff / 365);
			const years = timeDiff;
			if (years > 0) {
				return `${years > 1 ? this.$t("Routing.YearsAgo", {n: years}) : this.$t("Routing.YearAgo")}`;
			} else if (days > 0) {
				return `${days > 1 ? this.$t("Routing.DaysAgo", {n: days}) : this.$t("Routing.DayAgo")}`;
			} else if (hours > 0) {
				return `${hours > 1 ? this.$t("Routing.HoursAgo", {n: hours}) : this.$t("Routing.HourAgo")}`;
			} else if (minutes > 0) {
				return `${minutes > 1 ? this.$t("Routing.MinutesAgo", {n: minutes}) : this.$t("Routing.MinuteAgo")}`;
			} else if (seconds > 0) {
				return `${seconds > 1 ? this.$t("Routing.SecondsAgo", {n: seconds}) : this.$t("Routing.SecondAgo")}`;
			}
			return this.$t("Routing.SecondAgo");
		},
		// Method for creating dummy notification time
		randomDate({hr, min, sec}) {
			const date = new Date();
			if (hr) date.setHours(date.getHours() - hr);
			if (min) date.setMinutes(date.getMinutes() - min);
			if (sec) date.setSeconds(date.getSeconds() - sec);
			return date;
		},
		/**
		 * Adiciona o resta dias a una fecha espeficada
		 * @Param {String} stringDate fecha en formato string de la cual se va a restar o sumar
		 * @Param {Number} dayNums Entero positivo o negativo
		 */
		addOrLessDaysToDate(stringDate, dayNums) {
			const date = new Date(stringDate);
			return date.setDate(date.getDate() + dayNums);
		},
		/**
		 * Obtener todas las notificaciones desde firebase y suscribirse a los eventos
		 */
		async getNotifications() {
			// 1. Setup & Fetch Preferences
			await this.setupNotificationsPath();
			const preferences = await this.$store.dispatch("modulePreferences/getPreferences");
			this.applyPreferences(preferences);
			// 2. Setup Firebase Query
			const startAt = this.calculateStartDate();
			const starCountRef = this.createFirebaseQuery(startAt);
			// 3. Initial Fetch of Notifications
			this.fetchInitialNotifications(starCountRef);
			// 4. Setup Firebase Listeners
			this.setupFirebaseListeners(starCountRef);
		},
		async setupNotificationsPath() {
			this.pathRefNofication = `serviroutes/notification/${this.userData.serviroutes_company_id}`;
		},
		applyPreferences(preferences) {
			if (preferences) {
				this.notificationsDays = preferences.notifications_days;
				this.notificationsNumber = preferences.notifications_number;
				this.removeOldNotifications = preferences.remove_old_notifications;
				if (this.removeOldNotifications) this.getOldNotifications();
			}
		},
		calculateStartDate() {
			const date = this.addOrLessDaysToDate(new Date(), this.notificationsDays * -1);
			const currentDate = DateUtils.toDefaultDateTime(new Date(date), "YYYY-MM-DD");
			return currentDate.split("-").join("") + "000000";
		},
		createFirebaseQuery(startAt) {
			return this.database
				.ref(this.pathRefNofication)
				.orderByChild("added_on")
				.startAt(+startAt)
				.limitToLast(+this.notificationsNumber);
		},
		async fetchInitialNotifications(starCountRef) {
			await this.userSession.getUser();
			starCountRef.once("value", (snapshot) => {
				this.notifications = [];
				snapshot.forEach((childSnapshot) => {
					const key = childSnapshot.key;
					const notification = new Notification({
						...childSnapshot.val(),
						key: key,
					});
					const exist = this.notifications.some((n) => n.key === key);
					if (!exist && notification.status === "unread") {
						this.notifications.push(notification);
					}
				});
				this.totalUnreadNotifications = this.notifications.length;
			});
		},
		setupFirebaseListeners(starCountRef) {
			starCountRef.on("child_added", (data) => this.handleChildAdded(data));
			starCountRef.on("child_changed", (data) => this.handleChildChanged(data));
			starCountRef.on("child_removed", (data) => this.handleChildRemoved(data));
		},
		handleChildAdded(data) {
			if (data.val().event === "PROCESS") {
				const userInfo = JSON.parse(localStorage.userInfo);
				if (data.val().body.resource_id !== userInfo.datarutas_id) {
					return;
				}
			}
			this.addNotification(data.key, data.val());
			this.toggleShowWithDelay();
			setTimeout(() => {
				EventBus.$emit("listDocuments", data.val());
			}, 2000);
		},
		handleChildChanged(data) {
			this.setNotificationValues(data.key, data.val());
			this.toggleShowWithDelay();
			if (data.val().event === "FINALIZED") {
				this.handleFinalizedEvent(data.val());
			}
			if (data.val().status === "read") return;
			if (data.val().event === "ROUTING_DONE" || data.val().event === "OPTIMIZATION_DONE") {
				setTimeout(() => {
					this.$store.commit("setReadAvalibleEventsNotificationTrigger", data.val());
					EventBus.$emit("listDocuments", data.val());
				}, 5000);
			}
			if (data.val().event === "ROUTING_ERROR" || data.val().event === "OPTIMIZATION_ERROR") {
				setTimeout(() => {
					EventBus.$emit("listDocuments", data.val());
				}, 5000);
			}
			this.totalUnreadNotifications = this.notifications.length;
		},
		handleChildRemoved(data) {
			this.deleteNotification(data.key);
		},
		toggleShowWithDelay() {
			this.show = false;
			setTimeout(() => {
				this.show = true;
			}, 100);
		},
		handleFinalizedEvent(notification) {
			const userInfo = JSON.parse(localStorage.userInfo);
			if (notification.body.resource_id === userInfo.datarutas_id) {
				this.$vs.notify({
					color: "success",
					title: this.$t("Notification.FINALIZED"),
					text: `${this.$t("Reports.ReportGeneratedText")}. ${this.$t("Reports.ReportProcessFinish")}`,
					fixed: true,
				});
			}
		},
		/**
		 * Obtener y eliminar notificaciones previas al numero de dias espesificado en preferencias
		 */
		async getOldNotifications() {
			// Obtener la fecha actual y la completamos con el yiempo en 00 00 00
			const date = this.addOrLessDaysToDate(new Date(), this.notificationsDays * -1);
			const currentDate = DateUtils.toDefaultDateTime(new Date(date), "YYYY-MM-DD");
			const startAt = currentDate.split("-").join("") + "000000";
			await this.userSession.getUser();
			const starCountRef = this.database
				.ref(`serviroutes/notification/${this.userData.serviroutes_company_id}/`)
				.orderByChild("date")
				.endAt(+startAt)
				.limitToLast(+this.notificationsNumber);
			const oldNotifications = [];
			starCountRef.once("value", (snapshot) => {
				snapshot.forEach((childSnapshot) => {
					// key will be "ada" the first time and "alan" the second time
					let key = childSnapshot.key;
					const notification = new Notification({
						...childSnapshot.val(),
						key: key,
					});
					oldNotifications.push(notification);
				});
				this.deleteOldNotification(oldNotifications);
			});
		},
		async readNotification(notification, go = false) {
			await this.userSession.getUser();
			try {
				// Create a root reference
				const {key, ...restData} = notification;
				const notificationUp = new Notification(restData);
				notificationUp.status = "read";
				const starCountRef = this.database;
				starCountRef.ref(`serviroutes/notification/${this.company_id}/${key}`).set(notificationUp);
				if (go) this.goTo(notification);
			} catch (error) {
				throw new Error(error);
			}
		},
		async readAvalibleEventsNotification() {
			await this.userSession.getUser();
			try {
				// Create a root reference
				const starCountRef = this.database;
				this.notifications.forEach((notification) => {
					const key = notification.key;
					const notificationUp = new Notification(notification);
					notificationUp.status = "read";
					delete notificationUp.key;
					starCountRef.ref(`serviroutes/notification/${this.company_id}/${key}`).set(notificationUp);
				});
			} catch (error) {
				throw new Error(error);
			}
		},
		async readAllNotification() {
			await this.userSession.getUser();
			try {
				const starCountRef = this.database;
				starCountRef.ref(`serviroutes/notification/${this.userData.serviroutes_company_id}/`).set(null);
			} catch (error) {
				throw new Error(error);
			}
		},
		async deleteAllNotification() {
			try {
				await this.userSession.getUser();
				Array.from(this.notifications).forEach((notification) => {
					const starCountRef = this.database;
					starCountRef
						.ref(`serviroutes/notification/${this.userData.serviroutes_company_id}/`)
						.child(notification.key)
						.set(null);
				});
			} catch (error) {
				throw new Error(error);
			}
		},
		async deleteOldNotification(oldNotifications) {
			try {
				await this.userSession.getUser();
				Array.from(oldNotifications).forEach((notification) => {
					const starCountRef = this.database;
					starCountRef
						.ref(`serviroutes/notification/${this.userData.serviroutes_company_id}/`)
						.child(notification.key)
						.set(null);
				});
			} catch (error) {
				throw new Error(error);
			}
		},
		addNotification(key, data) {
			const d = {...data, key};
			const notification = new Notification(d);
			const exist = this.notifications.some((n) => n.key === key);
			if (!exist && notification.status === "unread") {
				this.notifications.unshift(notification);
			}
			this.totalUnreadNotifications = this.notifications.length;
		},
		deleteNotification(key) {
			const ItemIndex = this.notifications.findIndex((p) => p.key === key);
			this.notifications.splice(ItemIndex, 1);
			this.totalUnreadNotifications = this.notifications.length;
		},
		setNotificationValues(key, data) {
			const notificationIndex = this.notifications.findIndex((p) => p.key === key);
			if (notificationIndex >= 0) Object.assign(this.notifications[notificationIndex], data);
		},
		goTo({event, body}) {
			switch (event) {
				case "FINALIZED":
					this.$router.push({name: `apps-reports-list-id`, params: {id: body.job_id}}).catch(() => {});
					break;
				case "UPLOAD_VP_FINALIZED":
					return "primary";
				case "UPLOAD_VH_FINALIZED":
					return "primary";
				case "UPLOAD_VP_LOADED":
					return "success";
				case "UPLOAD_VH_LOADED":
					return "success";
				case "LOADED":
					return "success";
				case "UPLOAD_VP_PROCESS":
					return "danger";
				case "UPLOAD_VH_PROCESS":
					return "danger";
				default:
					return "secondary";
			}
		},
		/** comparar mayor por el atributo date */
		compare(a, b) {
			if (Date.parse(a.added_on) > Date.parse(b.added_on)) {
				return -1;
			}
			if (Date.parse(a.added_on) < Date.parse(b.added_on)) {
				return 1;
			}
			return 0;
		},
		showErrorAlert() {
			this.$vs.notify({
				color: "warning",
				title: this.$t("NewTypeConfigRequired"),
				text: this.$t("Roles.Permissions.JsonConfigNotFoundTex"),
				icon: "info",
				time: 6000,
			});
		},
		async getIdResourcesOnMessages() {
			const user = await this.userSession.getUser();
			const starMessagesCompanyRef = this.database.ref(`messages/${user.company_id}`);
			starMessagesCompanyRef.on("value", (snapshot) => {
				this.resourcesId = [];
				snapshot.forEach((childSnapshot) => {
					// key will be the resource id on the firt content
					let key = childSnapshot.key;
					// childData will be the actual contents of the child
					this.resourcesId.push(key);
				});
				this.filterMessages();
				this.unseenTotalMessages();
			});

			starMessagesCompanyRef.on("child_changed", (snapshot) => {
				let unseenMessages = 0;
				snapshot.forEach((childSnapshot) => {
					let childData = {...childSnapshot.val()};
					this.usernameSet.add(childData.user_name);
					if (childData.seen === false) {
						unseenMessages += 1;
					}
				});
				const childChanged = +snapshot.key;
				// verificamos si el elemento que cambio este en la lista de los actuales
				const recentCommunicationResources = this.$store.state.moduleResource.resourcesComunication;
				const someResource = recentCommunicationResources.some((resource) => resource.id === childChanged);

				// Si el recurso no se encuntra disparamos el trigger para actualizar la lista
				if (!someResource && unseenMessages > 0) {
					this.$store.commit("setUsernameResources", Array.from(this.usernameSet));
					this.$store.commit("setCommunicationMesaagesReload");

					// Capturamos el username del ultimo recurso agregado
					const lastUsernameAdded = [...this.usernameSet].pop();
					this.$vs.notify({
						color: "success",
						title: this.$t("Communication.Communication"),
						text: `${this.$t("Communication.NewMessage")} ${this.$t(
							"Resource.Resource"
						)} ${lastUsernameAdded.toUpperCase()}`,
						icon: "message",
						time: 7000,
					});
				}
			});
		},
		async filterMessages() {
			const user = await this.userSession.getUser();
			this.usernameSet = new Set();
			for (const resource of this.resourcesId) {
				const element = resource;
				const starMessagesCompanyRef = this.database
					.ref(`messages/${user.company_id}/${element}`)
					.orderByChild("state")
					.equalTo("Pendiente por resolver");
				starMessagesCompanyRef.once("value", (snapshot) => {
					snapshot.forEach((childSnapshot) => {
						// key will be "ada" the first time and "alan" the second time
						let key = childSnapshot.key;
						// childData will be the actual contents of the child
						let childData = {
							...childSnapshot.val(),
							key: key,
						};
						this.usernameSet.add(childData.user_name);
					});
				});
			}
			this.$store.commit("setUsernameResources", Array.from(this.usernameSet));
		},
		async unseenTotalMessages() {
			const user = await this.userSession.getUser();
			this.messages = [];
			for (const resource of this.resourcesId) {
				const element = resource;
				const starMessagesCompanyRef = this.database
					.ref(`messages/${user.company_id}/${element}`)
					.orderByChild("seen")
					.equalTo(false);
				starMessagesCompanyRef.once("value", (snapshot) => {
					snapshot.forEach((childSnapshot) => {
						// key will be "ada" the first time and "alan" the second time
						let key = childSnapshot.key;
						// childData will be the actual contents of the child
						let childData = {
							...childSnapshot.val(),
							key: key,
						};
						this.messages.push(childData);
					});
				});
			}

			this.$store.commit("setUnreadMessages", this.messages.flat());
		},
		confirmDeleteAllNotification() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Notification.DeleteAllNotifications"),
				accept: this.deleteAllNotification,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		setDataAlert() {
			let width = 400;
			let height = 400;
			let zoom = 19;
			let mapType = "roadmap";
			let key = process.env.VUE_APP_GOOGLE_MAP_API_KEY;
			this.url = `https://maps.googleapis.com/maps/api/staticmap?center=${this.lat},${this.lng}&zoom=${zoom}&size=${width}x${height}&maptype=${mapType}&markers=color:red|label:S|${this.lat},${this.lng}&key=${key}`;
		},
		showNotificationView(notification) {
			this.notificationSelected = notification;
			this.is_notification = false;
		},
	},
	watch: {
		notify_alert_configjson(val) {
			this.showErrorAlert();
		},
		readAvalibleEventsNotificationTrigger(val) {
			this.readAvalibleEventsNotification();
		},
		requiredPermissions(val) {
			this.$vs.notify({
				color: "danger",
				title: this.$t("Permissions.RequiredPermissions"),
				text: `${this.$t("Roles.Permissions.NotPermissionsText")} ${this.requiredPermissionsData.error}`,
				time: 7000,
				icon: "lock",
			});
		},
		deleteNotificationTrigger() {
			this.deleteAllNotification();
		},
		reloadNotificationTrigger(val) {
			this.notifications = [];
			this.totalUnreadNotifications = 0;
			setTimeout(() => {
				this.getNotifications();
			}, 200);
		},
	},
	filters: {
		format(str) {
			return str ? str.replace(/_/g, " ") : "";
		},
	},
	created() {
		// get messages for module comunication
		this.getIdResourcesOnMessages();
	},
	mounted() {
		const buttonNotification = document.querySelector(".button-notification");
		buttonNotification.addEventListener("mouseover", () => {
			if (this.is_notification === false) this.is_notification = true;
		});
		this.userData = JSON.parse(localStorage.userInfo);
		this.getNotifications();
	},
};
</script>

<style lang="scss" scoped>
.bounce-enter-active {
	animation: bounce-in 0.7s;
	color: #ff9f43;
}
.bounce-leave-active {
	animation: bounce-in 0.5s reverse;
	color: #ff9f43;
}
@keyframes bounce-in {
	0% {
		transform: scale(0);
	}
	50% {
		transform: scale(1.5);
	}
	100% {
		transform: scale(1);
	}
}
</style>
